import { render } from "./MoreWorks.vue?vue&type=template&id=75236f54"
import script from "./MoreWorks.vue?vue&type=script&lang=js"
export * from "./MoreWorks.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__